import axios from "axios";

const store = {
  state: {
    appModules: [],
    maintenanceMode: null,
  },
  getters: {
    getAppModule(state) {
      return state.appModules;
    },
    isUnderMaintenance(state) {
      return state.maintenanceMode == true;
    },
  },
  mutations: {
    INITIALIZE_APP_MODULE(state, payload) {
      let tmpAppModules = [];
      for (const module in payload) {
        if (payload[module] == true) {
          tmpAppModules.push(module);
        }
      }

      state.appModules = tmpAppModules;
    },
    INITIALIZE_MAINTENANCE_MODE(state, value) {
      state.maintenanceMode = value;
    },
  },
  actions: {
    initializeAppModule({ commit, state }, payload) {
      if (state.appModules.length == 0) {
        return new Promise((resolve, reject) => {
          axios
            .get(this._vm.$endpoints.user_app_module)
            .then((res) => {
              let response = res.data.data;
              commit("INITIALIZE_APP_MODULE", response);
              resolve(res);
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        });
      }
    },
    checkMaintenanceMode({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(this._vm.$endpoints.api_endpoint)
          .then((res) => {
            commit("INITIALIZE_MAINTENANCE_MODE", false);
            resolve(res);
          })
          .catch((err) => {
            const status_code = err.response ? err.response.data.status_code : null;
            if (status_code == 503) {
              commit("INITIALIZE_MAINTENANCE_MODE", true);
            }
            reject(err);
          });
      });
    },
  },
};

export default store;
